import React, { useState, useEffect } from "react";
import { FlatList, View, StyleSheet, Platform } from "react-native";

import AutocompleteOption from "./AutocompleteOption";
import ManaTextInput from "../ManaTextInput";
import { hasItems, isWeb } from "../../../../helpers/utils";
import Icons from "../icons";
import AppTheme from "../../AppTheme";

export default function AutocompleteView(props) {
  const {
    options,
    value,
    onChangeText = () => {},
    onOptionPress = () => {},
    onIconPressed = () => {},
  } = props;

  const [isCollapsed, setIsCollapsed] = useState(true);
  const hasOptions = hasItems(options);

  useEffect(() => {
    setIsCollapsed(!hasItems(options));
  }, [options]);

  const toggleIcon = () => {
    setIsCollapsed((prev) => !prev);
    onIconPressed(!isCollapsed);
  };

  return (
    <View style={styles.container}>
      <View style={styles.containerBorder}>
        <Icons.ArrowDropdown
          onPress={toggleIcon}
          style={styles.arrow}
          isOpen={!isCollapsed}
        />

        <ManaTextInput
          autoFocus
          disableBorder
          debounceDelay={700}
          contentHeight={30}
          style={[
            styles.autocompleteTextInput,
            hasOptions ? styles.borderBottom : {},
          ]}
          placeholderTextColor="#9C9EB9"
          name={"country"}
          placeholder="Enter Country Name"
          onTextChanged={(text) => onChangeText(text)}
          value={value || ""}
        />

        <View
          style={{
            maxHeight: 100,
            width: 257,
            position: "relative",
          }}
        >
          {hasOptions ? (
            <FlatList
              data={options}
              //keyboardShouldPersistTaps="always"
              renderItem={({ item }) => (
                <AutocompleteOption
                  onOptionPress={onOptionPress}
                  option={item}
                />
              )}
            />
          ) : null}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    //flex: 1,
    //minHeight: 150,
    height: 150,
    marginTop: 17,
  },
  containerBorder: {
    position: "relative",
    borderRadius: 4,
    borderWidth: 1,
    borderColor: AppTheme.DEFAULT_COLOR,
    padding: 5,
  },
  autocompleteTextInput: {
    width: 257,
    shadowOpacity: 0,
    elevation: 0,
    borderRadius: 0,
    marginBottom: 0,

    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
  },
  borderBottom: {
    borderBottomWidth: 1,
    borderBottomColor: "rgba(45, 49, 66, 0.3)",
  },
  arrow: {
    position: "absolute",
    right: 10,
    top: isWeb ? 12 : 22,
    zIndex: 2,
  },
});
